require('slick-carousel');

$('.logos-slick').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {breakpoint: 1024, settings: {slidesToShow: 3}},
        {breakpoint: 768, settings: {slidesToShow: 2}},
        {breakpoint: 568, settings: {slidesToShow: 1}}
    ]
});
